import styled from 'styled-components';

export const TableWrapper = styled.div`
  width: 100%;
  overflow-x: auto;
`;

export const StyledTable = styled.table`
  width: 100%;
  border-collapse: collapse;
`;

export const TableHead = styled.thead`
  background: ${({ theme }) => theme.landing.background};
`;

export const TableBody = styled.tbody``;

export const TableRow = styled.tr`
  border-bottom: 1px solid ${({ theme }) => theme.landing.cardBorder};

  &:hover {
    background: ${({ theme }) => theme.landing.iconBg};
  }
`;

export const TableHeaderCell = styled.th`
  padding: 14px 18px;
  text-align: left;
  font-size: 13px;
  font-weight: 600;
  color: ${({ theme }) => theme.landing.textSecondary};
`;

export const TableCell = styled.td`
  padding: 16px 18px;
  font-size: 14px;
  color: ${({ theme }) => theme.landing.text};
  vertical-align: middle;
  cursor: pointer;
`;

export const Actions = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
`;

export const IconButton = styled.button`
  width: 32px;
  height: 32px;

  display: flex;
  align-items: center;
  justify-content: center;

  border-radius: 6px;
  border: none;

  cursor: pointer;

  background: transparent;

  color: ${({ $danger }) => ($danger ? '#E53935' : 'var(--color-text-secondary)')};

  transition: 0.2s;

  &:hover {
    background: ${({ theme }) => theme.landing.background};
  }
`;

export const EmptyWrapper = styled.div`
  height: 420px;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  gap: 16px;

  color: ${({ theme }) => theme.landing.textSecondary};
`;

export const EmptyTitle = styled.h3`
  margin: 0;
`;

export const EmptyDescription = styled.p`
  margin: 0;
  font-size: 14px;
`;
